import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as styles from './MultiAccordionSection.scss';

var MultiAccordionSection = /*#__PURE__*/function (_Component) {
  _inherits(MultiAccordionSection, _Component);

  var _super = _createSuper(MultiAccordionSection);

  function MultiAccordionSection(props) {
    var _this;

    _classCallCheck(this, MultiAccordionSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleSection", function (sectionIndex) {
      if (_this.state.showSectionContent && sectionIndex === _this.state.selectedSectionIndex) {
        _this.setState({
          showSectionContent: false,
          selectedSectionIndex: null
        });
      } else {
        _this.setState({
          showSectionContent: true,
          selectedSectionIndex: sectionIndex
        });
      }
    });

    _this.state = {
      showSectionContent: false,
      selectedSectionIndex: null
    };
    return _this;
  }

  _createClass(MultiAccordionSection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 ".concat(styles.formSection)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-11 ".concat(styles.sectionLabels)
      }, this.props.sections.map(function (section, index) {
        return /*#__PURE__*/React.createElement("div", null, section.header, /*#__PURE__*/React.createElement("h4", {
          style: {
            opacity: _this2.state.selectedSectionIndex === index ? '1' : '0.7'
          },
          className: styles.toggleLabel,
          onClick: function onClick() {
            return _this2.toggleSection(index);
          },
          key: index
        }, section.label, _this2.state.selectedSectionIndex !== index ? /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-arrow-up ".concat(styles.downArrow)
        }) : /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-arrow-down ".concat(styles.downArrow)
        })));
      })), /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
        component: "div",
        transitionName: "slidedown",
        transitionEnterTimeout: 300,
        transitionLeaveTimeout: 300
      }, this.state.showSectionContent && this.state.selectedSectionIndex !== null && /*#__PURE__*/React.createElement("div", {
        className: styles.contentWrap
      }, this.props.sections[this.state.selectedSectionIndex].component)));
    }
  }]);

  return MultiAccordionSection;
}(Component);

_defineProperty(MultiAccordionSection, "propTypes", {
  sections: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.node,
    label: PropTypes.node,
    component: PropTypes.node.isRequired
  })).isRequired
});

_defineProperty(MultiAccordionSection, "styleguide", {
  title: 'MultiAccordionSection',
  sample_code: '<MultiAccordionSection />',
  props: {
    sections: [{
      header: 'section header',
      label: 'Sample Section',
      component: '<div className="preview">preview stuff</div>'
    }, {
      header: 'another header',
      label: 'Sample Section 2',
      component: '<div className="preview">another preview</div>'
    }]
  }
});

export { MultiAccordionSection as default };